export { default as equip } from "./equip";
